import React, { useEffect, useRef, useState } from "react";
import "./CustomRegistration.css";
import ImagePaths from "../../../Utility/ImagePaths";
import { Autocomplete, Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, Grid, List, ListItem, ListItemText, MenuItem, Paper, Radio, RadioGroup, Select, TextField, Typography } from "@mui/material";
import { calculateAgeFromBirthdate, calculateBirthdateFromAge, ToastMsg } from "../../CommonFunctions/CommonFuntions";
import CommonValidation from "../../CommonFunctions/CommonValidation";
import { City, Country, State } from "country-state-city";
import { formGet, get, post } from "../../../Utility/RestAPIService";
import { labels } from "../../../Utility/Constants";
import { SEARCH_MOBILE } from "../../../Utility/Serviceurls";

const TITLE = [
    { value: 'Mr', label: 'Mr' },
    { value: 'Ms', label: 'Ms' },
    { value: 'Mrs', label: 'Mrs' },
    { value: 'Master', label: 'Master' },
    { value: 'Baby', label: 'Baby' },
    { value: 'Baby of', label: 'Baby of' },
]

const GENDER_LIST = [
    { value: 'm', label: 'Male' },
    { value: 'f', label: 'Female' },
    { value: 't', label: 'Transgender' },
]

const RELATION_SHIP = [
    { value: 1, label: 'Father' },
    { value: 2, label: 'Husband' },
]

const FONT_SIZE_XS = '0.65rem'
const FONT_SIZE_SM = '0.65rem'
const FONT_SIZE_MD = '0.8rem'

let patientDataList = {
    patient_name: '',
    patient_title: '',
    patient_gender: '',
    patient_dob: '',
    patient_age: '',
    patient_martial_sts: '',
    patient_relationship_fat_hus: '',
    patient_father_hus_name: '',
    patient_address_one: '',
    patient_address_two: '',
    patient_city: '',
    patient_state: State.getStateByCode('TN'),
    patient_pincode: "",
    patient_occupation: '',
    patient_guardian_name: '',
    patient_mob_no: '',
    patient_email_id: '',
    patient_referral_source: '',
    agreement_check: false,
    patient_country: '',
    patient_id: null
}

const useOutsideClick = (ref, callback) => {
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, callback]);
};

export const KoyiliRegistrationForm = () => {
    const [patientData, setPatientData] = useState(patientDataList)
    const [referralSource, setReferralSource] = useState([])
    const [cityList, setCityList] = useState(City.getCitiesOfState('IN', 'TN'))
    const [stateList, setStateList] = useState(State.getStatesOfCountry('IN'))
    const [countryList, setCountryList] = useState(Country.getAllCountries())
    const [isErrorMsg, setIsErrorMsg] = useState(false);
    const [successMsg, setsuccessMsg] = useState(false);
    const [isErrorMsgText, setIsErrorMsgText] = useState('');
    const [successMsgText, setsuccessMsgText] = useState('');
    const [clinicData, setClinicData] = useState({})
    const [token, setToken] = useState('')
    const [postLoad, setPostLoad] = useState(false)
    const [getLoad, setGetLoad] = useState(true)
    const [language, setLanguage] = useState('tamil')
    const [filteredList, setFilteredList] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [lastSelectedPatient, setLastSelectedPatient] = useState(null);
    const dropdownRef = useRef(null);


    const errorMessage = (message) => {
        setIsErrorMsg(true)
        setIsErrorMsgText(message)
    }

    const successMessage = (message) => {
        setsuccessMsg(true)
        setsuccessMsgText(message)
    }

    const msgClose = () => {
        setIsErrorMsg(false)
        setIsErrorMsgText('')
        setsuccessMsg(false)
        setsuccessMsgText('')
    }

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString)
        const tokenFromUrl = urlParams.get('token')

        if (tokenFromUrl) {
            setToken(tokenFromUrl)
        }
    }, [])

    useEffect(() => {
        if (token) {
            getClinicData();
        }
    }, [token])

    useEffect(() => {
        if (patientData?.patient_pincode && patientData?.patient_pincode?.length === 6) {
            getPincodeToCity(patientData?.patient_pincode);
        }
        else if (patientData?.patient_pincode && patientData?.patient_pincode?.length <= 5) {
            setPatientData((prevPatientData) => ({
                ...prevPatientData,
                patient_city: ""

            }))
        }
    }, [patientData?.patient_pincode]);


    const getPincodeToCity = (pincode) => {
        fetch("https://api.postalpincode.in/pincode/" + pincode)
            .then((res) => res.json())
            .then((response) => {
                if (response && response[0]?.Status === "Success") {
                    let data = response[0]?.PostOffice;
                    if (data && data?.length > 0) {
                        setPatientData((prevPatientData) => ({
                            ...prevPatientData,
                            patient_city: data[0]?.District ? data[0]?.District : "",
                            //   patient_state:  data[0]?.State ? data[0]?.State : "",
                            //   patient_country: data[0]?.Country ? data[0]?.Country : ""
                        })
                        );
                    }
                } else if (response?.data?.status === "fail") {
                    // Handle fail case if needed
                }
            })
            .catch((e) => {
            });
    };

    const onChangeHandler = (e, key) => {
        try {
            let { value } = e.target
            switch (key) {
                case 'patient_age':
                    if (CommonValidation.numberOnly(value) && value <= 150 || value === '') {
                        setPatientData((prevPatientData) => ({
                            ...prevPatientData,
                            [key]: value,
                            patient_dob: value ? calculateAgeFromBirthdate(value) : ''
                        }))
                    }
                    break;
                case 'patient_dob':
                    setPatientData((prevPatientData) => ({
                        ...prevPatientData,
                        [key]: value,
                        patient_age: value ? calculateBirthdateFromAge(value) : ''
                    }))
                    break;
                case 'patient_name':
                    if (CommonValidation.alphabetOnly(value) && value?.length <= 32 || value === '') {
                        setPatientData((prevPatientData) => ({ ...prevPatientData, [key]: value }))
                    }
                    break;
                case 'patient_mob_no':
                    if (CommonValidation.numberOnly(value) && value?.length <= 10 || value === '') {
                        setPatientData((prevPatientData) => ({ ...prevPatientData, [key]: value }))
                        if (value.length === 10) {
                            searchPatient(value)
                        } else {
                            setShowDropdown(false);
                        }
                    }
                    break;
                case 'agreement_check':
                    setPatientData((prevPatientData) => ({ ...prevPatientData, [key]: e.target.checked }))
                    break;
                case 'patient_relationship_fat_hus':
                    setPatientData((prevPatientData) => ({ ...prevPatientData, [key]: value }))
                    break;
                case 'patient_pincode':
                    if (CommonValidation.numberOnly(value) && value?.length <= 6 || value === '') {
                        setPatientData((prevPatientData) => ({ ...prevPatientData, [key]: value }))
                    }
                    if (CommonValidation.numberOnly(value) && (value?.length < 6 || value === '')) {
                        setPatientData((prevPatientData) => ({
                            ...prevPatientData,
                            patientData: { ...prevPatientData.patientData }
                        }));
                    }
                    break;
                case 'patient_father_hus_name':
                    if (CommonValidation.alphabetOnly(value) && value?.length <= 32 || value === '') {
                        setPatientData((prevPatientData) => ({ ...prevPatientData, [key]: value }))
                    }
                    break;
                case 'patient_gender':
                    setPatientData((prevPatientData) => ({
                        ...prevPatientData,
                        [key]: value,
                        patient_title: value === 'm' ? 'Mr' : value === 'f' ? 'Ms' : '',
                    }))
                    break;
                case 'patient_title':
                    setPatientData((prevPatientData) => ({
                        ...prevPatientData,
                        [key]: value,
                        patient_gender: value === 'Mr' ? 'm' : (value === 'Ms' || value === 'Mrs') ? 'f' : '',
                        // patient_martial_sts: value === 'Mrs' ? 'Married' : ''
                    }))
                    break;
                case 'patient_occupation':
                    if (CommonValidation.alphabetOnly(value) && value?.length <= 45 || value === '') {
                        setPatientData((prevPatientData) => ({ ...prevPatientData, [key]: value }))
                    }
                    break;
                default:
                    if (value?.length <= 100 || value === '') {
                        setPatientData((prevPatientData) => ({ ...prevPatientData, [key]: value }))
                    }
                    break;
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const searchPatient = (mobileno) => {
        try {
            let clinicID = clinicData?.clinic_data?.clinic_id ? +clinicData?.clinic_data?.clinic_id : null
            formGet(`${SEARCH_MOBILE}?search_key=${mobileno}&clinic_id=${clinicID}`, token)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setFilteredList(response.data?.data);
                        setShowDropdown(response.data?.data?.length > 0);
                    }
                })
                .catch((e) => {
                    if (e.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const checkValidation = () => {
        try {
            let message = null;
            if (patientData.patient_name === '') {
                message = 'Enter Patient Name'
            } else if (patientData.patient_gender === '') {
                message = 'Enter Patient Gender'
            } else if (patientData.patient_dob === '') {
                message = 'Enter Patient Date of Birth'
            } else if (patientData.patient_father_hus_name === '' && +clinicData?.organization_id !== 766) {
                message = 'Enter Patient Father or Husband Name'
            } else if (patientData.patient_father_hus_name !== '' && patientData.patient_relationship_fat_hus === '' && +clinicData?.organization_id !== 766) {
                message = 'Select Patient Father or Husband Relationship'
            } else if (patientData?.patient_city === '') {
                message = 'Select Patient City'
            } else if (patientData?.patient_address_one === '') {
                message = 'Enter Patient address 01'
            } else if (patientData.patient_mob_no === '') {
                message = 'Enter Patient Mobile Number'
            } else if (patientData.patient_mob_no !== '' && patientData?.patient_mob_no?.length < 10) {
                message = 'Invalid Mobile Number'
            } else if (!patientData?.agreement_check) {
                message = 'Please Click the Terms & Conditions'
            }
            return message;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getClinicData = () => {
        try {
            let GET_CLINIC_DATA = `fo/qr-decrypt-token-details/`
            formGet(GET_CLINIC_DATA, token).then((response) => {
                if (response.data.status === 'success') {
                    setClinicData(response.data.data)
                    setReferralSource(response?.data?.data?.referral_source)
                    setGetLoad(false)
                    setLanguage(response?.data?.data?.regional_language || 'tamil')
                    let clinic_state = response?.data?.data?.clinic_data?.state_name
                    let clinic_city = response?.data?.data?.clinic_data?.city_name
                    let List = State.getAllStates()?.find(item => item?.name?.toLowerCase() === clinic_state?.toLowerCase())
                    let stateList = State.getStatesOfCountry(List?.countryCode || 'IN')
                    let cityList = City.getCitiesOfState(List?.countryCode || 'IN', List?.isoCode || 'TN')
                    setStateList(stateList)
                    setCityList(cityList)
                    setPatientData((prev) => ({ ...prev, patient_city: clinic_city, patient_state: List }))
                }
            }).catch((error) => {
                setGetLoad(false)
                if (error?.response?.data?.message) {
                    errorMessage(error.response.data.message)
                } else {
                    errorMessage(error.message)
                }
            })
        } catch (error) {
            setGetLoad(false)
            errorMessage(error.message)
        }
    }

    const onSubmitHandler = () => {
        try {
            let REGISTRATION_FORM_POST = 'fo/qr-appointment/registration/'
            let stateName = stateList.find((item) => (item.isoCode === patientData?.patient_state?.isoCode))?.name
            let data = {
                // "clinic_id": clinicData?.clinic_data?.clinic_id ? clinicData?.clinic_data?.clinic_id : null,
                "patient_name": patientData.patient_name ? patientData.patient_name : "",
                "gender": patientData.patient_gender ? patientData.patient_gender?.value : "",
                "dob": patientData.patient_dob ? patientData?.patient_dob : null,
                "age": patientData?.patient_age ? patientData?.patient_age : 0,
                "address_line_1": patientData?.patient_address_one ? patientData?.patient_address_one : "",
                'address_line_2': patientData?.patient_address_two ? patientData?.patient_address_two : "",
                "pincode": patientData?.patient_pincode ? patientData?.patient_pincode : "",
                "mobile_number": patientData?.patient_mob_no ? patientData?.patient_mob_no : "",
                "email": patientData?.patient_email_id ? patientData?.patient_email_id : null,
                'father_name': patientData?.patient_father_hus_name ? patientData?.patient_father_hus_name : "",
                "referral_source": patientData?.patient_referral_source ? patientData?.patient_referral_source : '',
                'marital_status': patientData?.patient_martial_sts ? patientData?.patient_martial_sts : '',
                'guardian_name': patientData?.patient_guardian_name ? patientData?.patient_guardian_name : '',
                'occupation': patientData?.patient_occupation ? patientData?.patient_occupation : '',
                'title': patientData?.patient_title ? patientData?.patient_title?.value : '',
                'city': patientData?.patient_city ? patientData?.patient_city : '',
                'state': stateName ? stateName : patientData?.patient_state ? patientData?.patient_state : '',
                'country': 'India',
                'relationship_label': patientData?.patient_relationship_fat_hus ? patientData?.patient_relationship_fat_hus?.value : null,
                'organization_id': clinicData?.organization_id ? +clinicData?.organization_id : null,
                'branch_id': clinicData?.branch_id ? clinicData?.branch_id : null,
                'patient_id': patientData?.patient_id || null,
            }
            let checkValid = checkValidation()
            if (checkValid === null) {
                post(REGISTRATION_FORM_POST, data).then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setPatientData(patientDataList)
                        getClinicData()
                        setPostLoad(false)
                    }
                }).catch((error) => {
                    setPostLoad(false)
                    if (error?.response?.data?.message) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
            } else {
                setPostLoad(false)
                errorMessage(checkValid)
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onSelectPatient = (item) => {
        const selectedGender = GENDER_LIST.find(
            (gender) => gender.label.toLowerCase() === item?.patient_gender?.trim().toLowerCase()
        );
        const relation = RELATION_SHIP.find(
            (relation) => relation.value === +item?.relationship_label
        );
        const title = TITLE.find(
            (title) => title.label.toLowerCase() === item?.title?.trim().toLowerCase()
        );
        const ageMatch = item?.patient_age?.match(/^(\d+)Y/);
        const age = ageMatch ? ageMatch[1] : '';
        setPatientData((prevPatientData) =>
        ({
            ...prevPatientData,
            patient_name: item?.first_name || '',
            patient_title: title || '',
            patient_gender: selectedGender || '',
            patient_dob: item?.dob || '',
            patient_age: age || '',
            patient_martial_sts: item?.marital_status === 'Single' ? 'Unmarried' : item?.marital_status,
            patient_father_hus_name: item?.father_husband_name || '',
            patient_address_one: item?.address_line_1 || '',
            patient_address_two: item?.address_line_2 || '',
            patient_city: item?.city__city_name || '',
            patient_state: State.getStateByCode('TN'),
            patient_pincode: item?.pincode || '',
            patient_occupation: item?.occupation || '',
            patient_guardian_name: item?.guardian || '',
            patient_relationship_fat_hus: relation || '',
            patient_id: item?.patient_id || null
        }))
        setShowDropdown(false);
        setLastSelectedPatient({
            patient_name: item?.first_name || '',
            patient_mob_no: patientData?.patient_mob_no || '',
            patient_age: age || '',
            patient_dob: item?.dob || '',
            patient_gender: selectedGender || '',
        });
    };

    useEffect(() => {
        if (patientData.patient_id !== null && lastSelectedPatient) {
            const criticalFields = ['patient_name', 'patient_mob_no', 'patient_age', 'patient_dob', 'patient_gender'];
            const hasChangedFromSelectedPatient = criticalFields.some(key => {
                return patientData[key] !== lastSelectedPatient[key];
            });

            if (hasChangedFromSelectedPatient) {
                setPatientData(prev => ({
                    ...prev,
                    patient_id: null
                }));
            }
        }
    }, [patientData.patient_name, patientData.patient_mob_no, patientData.patient_age, patientData.patient_dob, patientData.patient_gender]);
    useOutsideClick(dropdownRef, () => {
        if (showDropdown) setShowDropdown(false);
    });
    return (
        getLoad ? <Box
            sx={{
                border: "0.5dvw solid #04B7B1",
                margin: { xs: "2dvh 5dvw", sm: "2dvh 10dvw", lg: "2dvh 20dvw" },
                borderRadius: "0.5dvw",
                boxShadow: '0 0 10px 5px #DCD8D8',
                display: 'flex', justifyContent: 'center', alignContent: 'center', height: '100dvh'
            }}><CircularProgress color="primary" /></Box> :
            <Box
                sx={{
                    border: "0.5dvw solid #04B7B1",
                    margin: { xs: "2dvh 5dvw", sm: "2dvh 10dvw", lg: "2dvh 20dvw" },
                    borderRadius: "0.5dvw",
                    boxShadow: '0 0 10px 5px #DCD8D8'
                }}
            >
                {/* Header Image */}
                <Box display="flex" justifyContent="center" sx={{ mb: "1dvh" }}>
                    <Box
                        component="img"
                        src={Object.keys(clinicData)?.length > 0 ? clinicData?.clinic_data?.clinic_header_url : ImagePaths.RajeshHeader}
                        alt="Header"
                        sx={{
                            width: { xs: "85dvw", sm: "75dvw", md: "55dvw" },
                            height: "auto",
                        }}
                    />
                </Box>

                {/* Form Title */}
                <Box sx={{ backgroundColor: "#E4F2F0", p: "0.5dvw", textAlign: "center" }}>
                    <Typography
                        color="#006C69"
                        fontWeight={600}
                        sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}
                    // className="eMed_custom_font_size"
                    >
                        Out Patient Registration Information Form
                    </Typography>
                    <Typography
                        color="#006C69"
                        fontWeight={600}
                        sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}
                    >
                        {labels[language]?.formHeader}
                    </Typography>
                </Box>

                <Box sx={{ p: "2dvw", borderBottom: '1px solid lightgray' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`Mobile No / ${labels[language]?.mobileNo} *`}</Typography>
                            <Box sx={{ position: 'relative', width: '100%' }}>
                                <TextField size="small" sx={{ width: "100%", fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}
                                    autoComplete="off"
                                    value={patientData?.patient_mob_no}
                                    error={!(patientData?.patient_mob_no && patientData?.patient_mob_no?.length === 10)}
                                    onChange={(e) => onChangeHandler(e, 'patient_mob_no')}
                                />
                                {showDropdown && (
                                    <Paper ref={dropdownRef} style={{ width: '100%', maxHeight: 150, overflowY: 'auto', marginTop: 2, position: 'absolute', zIndex: 1000, }}>
                                        <List>
                                            {filteredList.map((item, index) => (
                                                <ListItem button key={index} onClick={() => onSelectPatient(item)}>
                                                    <ListItemText primary={`${item.first_name || '-'}, ${item.patient_age || '-'}`} />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Paper>
                                )}
                            </Box>
                        </Grid>

                        {/* row One */}
                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`Patient Name / ${labels[language]?.patientName} *`}</Typography>
                            {/* <FormControl size="small" sx={{ width: '20%' }} className="eMed_custom_font_size">
                                <Select
                                    value={patientData.patient_title}
                                    onChange={(e) => onChangeHandler(e, 'patient_title')}
                                >
                                    {TITLE?.map((item, index) => {
                                        return (<MenuItem key={index} value={item?.value}>{item?.label}</MenuItem>)
                                    })}
                                </Select>
                            </FormControl> */}
                            <Box display={'flex'}>
                                <Autocomplete
                                    clearIcon
                                    size="small"
                                    // freeSolo
                                    options={TITLE}
                                    disableClearable={true}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option.label}
                                    value={patientData?.patient_title}
                                    onChange={(e, newValue) => {
                                        setPatientData((prevPatientData) => ({
                                            ...prevPatientData,
                                            patient_title: newValue,
                                            patient_gender: newValue?.value === 'Mr' ? { label: 'Male', value: 'm' } : (newValue?.value === 'Ms' || newValue?.value === 'Mrs') ? { label: 'Female', value: 'f' } : '',
                                        }))
                                    }}
                                    sx={{ width: '20%' }}
                                    renderInput={(params) => <TextField {...params} error={!patientData?.patient_title} sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }} />}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option?.label}>
                                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}>{option?.label}</Typography>
                                        </li>
                                    )}
                                />
                                <TextField size="small" sx={{ width: "80%", fontSize: "1dvw" }}
                                    autoComplete="off"
                                    value={patientData.patient_name}
                                    error={!patientData?.patient_name}
                                    onChange={(e) => onChangeHandler(e, 'patient_name')}
                                />
                            </Box>

                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`Gender / ${labels[language]?.gender} *`}</Typography>
                            {/* <FormControl size="small" sx={{ width: '100%', fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}>
                                <Select
                                    value={patientData.patient_gender}
                                    onChange={(e) => onChangeHandler(e, 'patient_gender')}
                                >
                                    {GENDER_LIST?.map((item, index) => {
                                        return (<MenuItem key={index} value={item?.value}>{item?.label}</MenuItem>)
                                    })}
                                </Select>
                            </FormControl> */}
                            <Autocomplete
                                clearIcon
                                size="small"
                                options={GENDER_LIST}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.label}
                                value={patientData?.patient_gender}
                                onChange={(e, newValue) => {
                                    setPatientData((prevPatientData) => ({
                                        ...prevPatientData,
                                        patient_gender: newValue,
                                        patient_title: (patientData?.patient_title?.value === "Master" || patientData?.patient_title?.value === "Baby" || patientData?.patient_title?.value === "Baby of") ? patientData?.patient_title : newValue?.value === 'm' ? { label: 'Mr', value: 'Mr' } : newValue?.value === 'f' ? { label: 'Ms', value: 'Ms' } : '',
                                    }))
                                }}
                                sx={{ width: '100%' }}
                                renderInput={(params) => <TextField {...params} error={!patientData?.patient_gender} sx={{ width: '100%', fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }} />}
                                renderOption={(props, option) => (
                                    <li {...props} key={option?.label}>
                                        <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}>{option?.label}</Typography>
                                    </li>
                                )}
                            />
                        </Grid>
                        {/* Row Two */}
                        <Grid item xs={12} sm={6} display={'flex'}>
                            <Box component={'div'} width={'70%'} mr={'0.5dvw'}>
                                <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`Date of Birth / ${labels[language]?.DOB} *`}</Typography>
                                <TextField type="date" size="small" 
                                    sx={{
                                        width: '98%',
                                        '& input': {
                                            WebkitAppearance: 'none',
                                            minHeight: '2.5rem',
                                            fontSize: { xs: '16px', sm: '14px' },
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            height: '40px',
                                        }
                                    }}
                                    autoComplete="off"
                                    value={patientData.patient_dob}
                                    error={!patientData?.patient_dob}
                                    onChange={(e) => onChangeHandler(e, 'patient_dob')}
                                />
                            </Box>
                            <Box component={'div'} width={'30%'}>
                                <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`Age / ${labels[language]?.age}`}</Typography>
                                <TextField size="small" sx={{ width: "100%", fontSize: "1dvw" }}
                                    autoComplete="off"
                                    value={patientData.patient_age}
                                    onChange={(e) => onChangeHandler(e, 'patient_age')}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`Marital Status / ${labels[language]?.maritalStatus}`}</Typography>
                            <RadioGroup
                                row
                                value={patientData?.patient_martial_sts}
                                onChange={(e) => onChangeHandler(e, 'patient_martial_sts')}
                            >
                                <FormControlLabel value="Unmarried" control={<Radio size="small" />} label={<Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>Unmarried /<br /> {`${labels[language]?.unMarried}`}</Typography>} />
                                <FormControlLabel value="Married" control={<Radio size="small" />} label={<Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>Married /<br /> {`${labels[language]?.married}`}</Typography>} />
                            </RadioGroup>
                        </Grid>

                        {/* row 3 */}
                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`Father/ Husband Name / ${labels[language]?.fatherHusbandName} ${+clinicData?.organization_id === 766 ? '' : '*'}`}</Typography>
                            {/* <FormControl size="small" sx={{ fontSize: "1.2dvw", width: '30%' }}>
                                <Select
                                    value={patientData?.patient_relationship_fat_hus}
                                    onChange={(e) => onChangeHandler(e, 'patient_relationship_fat_hus')}
                                >
                                    {RELATION_SHIP?.map((item, index) => {
                                        return (<MenuItem key={index} value={item?.value}>{item?.label}</MenuItem>)
                                    })}
                                </Select>
                            </FormControl> */}
                            <Box component={'div'} display={'flex'}>
                                <Autocomplete
                                    clearIcon
                                    size="small"
                                    // freeSolo
                                    options={RELATION_SHIP}
                                    getOptionLabel={(option) => typeof (option) === 'string' ? option : option.label}
                                    value={patientData?.patient_relationship_fat_hus}
                                    onChange={(e, newValue) => {
                                        setPatientData((prevPatientData) => ({
                                            ...prevPatientData,
                                            patient_relationship_fat_hus: newValue
                                        }))
                                    }}
                                    sx={{ width: '30%' }}
                                    renderInput={(params) => <TextField {...params} error={!patientData?.patient_relationship_fat_hus && +clinicData?.organization_id !== 766} sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }} />}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option?.label}>
                                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}>{option?.label}</Typography>
                                        </li>
                                    )}
                                />
                                <TextField size="small" sx={{ width: "70%", fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}
                                    autoComplete="off"
                                    value={patientData?.patient_father_hus_name}
                                    error={!patientData?.patient_father_hus_name && +clinicData?.organization_id !== 766}
                                    onChange={(e) => onChangeHandler(e, 'patient_father_hus_name')}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`Address 01 /${labels[language]?.address1}*`}</Typography>
                            <TextField size="small" sx={{ width: "100%", fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}
                                autoComplete="off"
                                value={patientData?.patient_address_one}
                                error={!patientData?.patient_address_one}
                                onChange={(e) => onChangeHandler(e, 'patient_address_one')}
                            />
                        </Grid>

                        {/* row 4 */}

                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`Address 02 /${labels[language]?.address2}`}</Typography>
                            <TextField size="small" sx={{ width: "100%", fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}
                                autoComplete="off"
                                value={patientData?.patient_address_two}
                                onChange={(e) => onChangeHandler(e, 'patient_address_two')}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`City/${labels[language]?.city}*`}</Typography>
                            <Autocomplete
                                clearIcon
                                size="small"
                                options={cityList}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.name}
                                value={patientData?.patient_city ? patientData?.patient_city : null}
                                onChange={(e, value) => {
                                    setPatientData((prevPatientData) => ({ ...prevPatientData, patient_city: value?.name }))
                                }}
                                renderInput={(params) => <TextField {...params} error={!patientData?.patient_city} sx={{ width: '100%', fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }} />}
                                renderOption={(props, option) => (
                                    <li {...props} key={option?.name}>
                                        <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}>{option?.name}</Typography>
                                    </li>
                                )}
                            />
                        </Grid>

                        {/* row 5 */}

                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`State/${labels[language]?.state}*`}</Typography>
                            <Autocomplete
                                clearIcon
                                size="small"
                                options={stateList}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.name}
                                value={patientData?.patient_state}
                                onChange={(e, value) => {
                                    let cityData = [];
                                    cityData = City.getCitiesOfState('IN', value?.isoCode)
                                    setPatientData((prevPatientData) => ({
                                        ...prevPatientData,
                                        patient_state: value,
                                        patient_city: ''
                                    }))
                                    setCityList(cityData)
                                }}
                                renderInput={(params) => <TextField {...params} error={!patientData?.patient_state} sx={{ width: '100%', fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }} />}
                                renderOption={(props, option) => (
                                    <li {...props} key={option?.name}>
                                        <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}>{option?.name}</Typography>
                                    </li>
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`Pin-code /${labels[language]?.pincode}`}</Typography>
                            <TextField size="small" sx={{ width: "100%", fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}
                                autoComplete="off"
                                value={patientData?.patient_pincode}
                                onChange={(e) => onChangeHandler(e, 'patient_pincode')}
                            />
                        </Grid>

                        {/* row 6 */}

                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`Occupation / ${labels[language]?.occupation}`}</Typography>
                            <TextField size="small" sx={{ width: "100%", fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}
                                autoComplete="off"
                                value={patientData?.patient_occupation}
                                onChange={(e) => onChangeHandler(e, 'patient_occupation')}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`Guardian Name/${labels[language]?.guardianName}`}</Typography>
                            <TextField size="small" sx={{ width: "100%", fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}
                                autoComplete="off"
                                value={patientData?.patient_guardian_name}
                                onChange={(e) => onChangeHandler(e, 'patient_guardian_name')} />

                        </Grid>

                        {/* row 7 */}
                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`Email Id / ${labels[language]?.emailId}`}</Typography>
                            <TextField size="small" sx={{ width: "100%", fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }}
                                autoComplete="off"
                                value={patientData?.patient_email_id}
                                onChange={(e) => onChangeHandler(e, 'patient_email_id')}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box component={'div'} sx={{ p: "1dvw 2dvw", borderBottom: '1px solid lightgray' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`How do you know about ${clinicData?.clinic_data?.clinic_name ? clinicData?.clinic_data?.clinic_name : "us"}?`}</Typography>
                            <Autocomplete
                                clearIcon
                                size="small"
                                options={referralSource}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : option.source_name}
                                value={patientData?.patient_referral_source}
                                onChange={(e, value) => {
                                    setPatientData((prevPatientData) => ({
                                        ...prevPatientData,
                                        patient_referral_source: value?.source_name
                                    }))
                                }}
                                renderInput={(params) => <TextField {...params} sx={{ width: '100%', fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD } }} />}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box component={'div'} sx={{ p: "1dvw 2dvw", borderBottom: '1px solid lightgray' }}>
                    <FormControlLabel sx={{ marginRight: "0px" }} control={<Checkbox checked={patientData?.agreement_check} onChange={(e) => onChangeHandler(e, 'agreement_check')} />} label={<Typography component={'details'}>
                        <Typography component={'summary'} sx={{ fontSize: { xs: FONT_SIZE_XS, sm: FONT_SIZE_SM, md: FONT_SIZE_MD, fontWeight: 'bold' } }}>{`I agree to the Terms & Conditions for booking this appointment / ${labels[language]?.terms}`}</Typography>
                        <Typography component={'p'} fontSize={'0.7rem'}>
                            {`I have been informed of the rules, regulations, and charges related to treatment at the hospital.
                        I give my consent to be examined (or the patient for whom I am responsible to be examined) by the hospital's doctors and nurses. This includes undergoing necessary tests, procedures, and treatments as prescribed by the healthcare providers.
                        I understand that the medical staff will take all reasonable precautions for my well-being and safety, but I acknowledge that inherent risks are associated with any medical procedure or treatment.`}
                        </Typography>
                        <Typography component={'p'} fontSize={'0.7rem'} mt={'0.25vw'}>
                            {labels[language]?.description}
                        </Typography>
                    </Typography>} />
                </Box>
                <Box component={'div'} sx={{ p: "1dvw 2dvw", display: 'flex', justifyContent: 'center' }}>
                    <Button
                        variant="contained" disabled={(postLoad) || (patientData.patient_name === '' || patientData.patient_gender === '' || patientData.patient_dob === '' || (patientData.patient_father_hus_name === '' && +clinicData?.organization_id !== 766) || (patientData.patient_father_hus_name !== '' && patientData.patient_relationship_fat_hus === '' && +clinicData?.organization_id !== 766) || patientData?.patient_city === '' || patientData?.patient_address_one === '' || (!patientData.patient_mob_no) || !patientData?.agreement_check)}
                        sx={{ width: '15dvw', textTransform: 'capitalize' }}
                        onClick={() => {
                            setPostLoad(true)
                            onSubmitHandler()
                        }}
                    >Submit</Button>
                </Box>
                <div className="imagesall" data-testid="eMed_imagesall">
                    <div className="emedlogo">
                        <span className="alreadypat" style={{ fontWeight: '600' }}><p data-testid="eMed_emedLogoText">Download EmedHub </p> To view your reports and bills</span>
                    </div>
                    <div className="appstoreandplaystore" data-testid="eMed_appstoreAndPlaystore">
                        <a href="https://apps.apple.com/us/app/emedhub/id6475773185?platform=iphone*" target="_blank" rel="nofollow" data-testid="eMed_appstoreLink"> <img src={ImagePaths.AppStoreNew} alt="Header" data-testid="eMed_appstoreImage" /></a>
                        <a href="https://play.google.com/store/apps/details?id=com.emedhub.clinic&pcampaignid=web_share" target="_blank" rel="nofollow" className="playstore" data-testid="eMed_playstoreLink"> <img src={ImagePaths.PlayStoreNew} alt="Header" data-testid="eMed_playstoreImage" /></a>
                    </div>
                </div>
                {
                    isErrorMsg ?
                        <ToastMsg
                            severity={'error'}
                            msg={isErrorMsgText}
                            msgPop={msgClose.bind(this)}
                        />
                        : null
                }
                {
                    successMsg ?
                        <ToastMsg
                            severity={'success'}
                            msg={successMsgText}
                            msgPop={msgClose.bind(this)}
                        />
                        : null
                }
            </Box>


    );
};
